export const getSheetLayout = (isMobile, isCompact) => {
	if (isMobile) return 'mobile'
	return isCompact ? 'tablet' : 'desktop'
}
